module.exports = __webpack_public_path__ + "static/media/avaamo.df0d0cb6.svg";


//////////////////
// WEBPACK FOOTER
// ./src/App/assets/avaamo.svg
// module id = 68
// module chunks = 0